// plugins/compare-init.client.ts
export default defineNuxtPlugin(() => {
  const compareStore = useCompareStore()
  compareStore.initFromStorage()
})
